// import { getToken, getSession } from 'utils/token';
// import Configs from 'config/config';
// import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import moment from 'moment-timezone';
// const env = process.env.NODE_ENV;
import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['RouteMaster', 'RouteGroup'],
});

export const routeMasterApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllRouteMasters: builder.query({
      query: () => `routes/`,
      providesTags: ['RouteMaster'],
    }),
    findRouteMasterById: builder.query({
      query: (id) => `routes/${id}/`,
      keepUnusedDataFor: 0, // No cache
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'RouteMaster', id: result.id }]
          : ['RouteMaster'];
      },
    }),
    createRouteMaster: builder.mutation({
      query: (routeMaster) => ({
        url: `routes/`,
        method: 'POST',
        body: routeMaster,
      }),
      invalidatesTags: ['RouteMaster', 'RouteGroup'],
    }),
    updateRouteMaster: builder.mutation({
      query: (routeMaster) => ({
        url: `routes/${routeMaster.id}/`,
        method: 'PUT',
        body: routeMaster,
      }),
      invalidatesTags: ['RouteMaster'],
    }),
    deleteRouteMaster: builder.mutation({
      query: (id) => ({
        url: `routes/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['RouteMaster', 'RouteGroup'],
    }),
    findAllRouteGroups: builder.query({
      query: () => `route_groups/`,
      providesTags: ['RouteGroup'],
    }),
    findAllRouteGroupsByPagination: builder.query({
      query: (payload) => {
        let url = `route_groups/`;
        let params = {};
        if (payload) {
          Object.keys(payload).forEach((key) => {
            if (payload[key] !== null) {
              params[key] = payload[key];
            }
          });
        }
        return { url, params: params };
      },
      keepUnusedDataFor: 0,
    }),
    findRouteGroupByODPoints: builder.query({
      query: ({ origin, destination }) => {
        return `route_groups/?origin=${origin}&destination=${destination}`;
      },
      keepUnusedDataFor: 0, // No cache
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'RouteGroup', id: result.id }]
          : ['RouteGroup'];
      },
    }),
    createRouteGroup: builder.mutation({
      query: (routeGroup) => ({
        url: `route_groups/`,
        method: 'POST',
        body: routeGroup,
      }),
      invalidatesTags: ['RouteGroup'],
    }),
    updateRouteGroup: builder.mutation({
      query: (routeGroup) => ({
        url: `route_groups/${routeGroup.id}/`,
        method: 'PATCH',
        body: routeGroup,
      }),
      invalidatesTags: ['RouteGroup'],
    }),
    findRouteGroupById: builder.query({
      query: (id) => `route_groups/${id}/`,
      keepUnusedDataFor: 0, // No cache
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'RouteGroup', id: result.id }]
          : ['RouteGroup'];
      },
    }),
    deleteRouteGroup: builder.mutation({
      query: ({ id }) => ({
        url: `route_groups/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['RouteGroup'],
    }),
    findOdRouting: builder.query({
      query: ({ st_lat, st_lng, en_lat, en_lng }) =>
        `od_routing/?date_time=${moment().format(
          'YYYY-MM-DDTHH:mm:ss'
        )}&st_lat=${st_lat}&st_lng=${st_lng}&en_lat=${en_lat}&en_lng=${en_lng}&toll=0&user=leaftech`,
    }),
    findWayPointsRouting: builder.query({
      query: ({ encodedWayPoints, tollway }) =>
        `waypoints_routing/?date_time=${moment().format(
          'YYYY-MM-DDTHH:mm:ss'
        )}&polyline=${encodedWayPoints}&service_time=0&vehicle_type=8&toll=${tollway}&user=leaftech`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllRouteMastersQuery,
  useFindRouteMasterByIdQuery,
  useCreateRouteMasterMutation,
  useUpdateRouteMasterMutation,
  useDeleteRouteMasterMutation,
  useFindOdRoutingQuery,
  useFindWayPointsRoutingQuery,
  // Route group
  useFindAllRouteGroupsQuery,
  useFindRouteGroupByIdQuery,
  useFindRouteGroupByODPointsQuery,
  useCreateRouteGroupMutation,
  useUpdateRouteGroupMutation,
  useDeleteRouteGroupMutation,
} = routeMasterApi;
